import { useEffect, useMemo, useState } from 'react'
import { useIpLocation } from './useIpLocation'
import features from '../../components/features'

export const useDeviceLocation = (enabled) => {
  const [geolocation, setGeolocation] = useState({
    latitude: undefined,
    longitude: undefined,
  })
  const { data: ipLocation } = useIpLocation(enabled)

  useEffect(() => {
    if (!features.useBrowserGeolocation) {
      return
    }
    if (!enabled || !!geolocation.latitude) {
      return
    }
    if ('geolocation' in navigator === false) {
      return
    }

    navigator.geolocation.getCurrentPosition((position) => {
      setGeolocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      })
    })
  }, [enabled, geolocation.latitude])

  const location = useMemo(() => {
    if (geolocation.latitude && geolocation.longitude) {
      return { ...geolocation }
    }
    if (ipLocation?.latitude) {
      return { ...ipLocation }
    }
    return null
  }, [ipLocation, geolocation])

  return location
}
